<template>
  <v-row>
    <v-col class="pt-0 pb-4">
      <v-row align="center" no-gutters>
        <v-col cols="auto" class="mr-4">
          <p class="all-caps-header mb-0">{{sectionName}}</p>
        </v-col>
        <v-col v-if="$slots.headerAction" cols="auto" class="header-action-col">
          <slot name="headerAction"/>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <slot/>
        </v-col>
      </v-row>
      <v-divider class="mt-7" v-if="hideDivider === false"/>
    </v-col>
  </v-row>
</template>
<script lang="ts">
import {Vue, Component, Prop} from 'vue-property-decorator';

@Component
export default class MultiformSection extends Vue {
  @Prop({required: true, type: String,})
  public readonly sectionName!: string;

  @Prop({required: false, default: false,})
  public readonly hideDivider!: boolean;
}
</script>
<style scoped lang="scss">
.header-action-col {
  max-width: 450px;
}
</style>
